<template>
    <div class="homeMap">
        <div class="main">
            <div class="titbox">
                <h3>Handle全球根节点分布图</h3>
                <!-- <p>Handle全球管理机构DONA基金会目前授权认证了10个Handle全球根节点</p> -->
            </div>
            <div class="mapbox">
                <div class="mapImg">
                    <img src="../../assets/img/home/map.png" alt="">
                </div>
                <div class="nameLists nameList-1">
                    <i class="nameWave-1"></i>
                    <i class="nameWave-2"></i>
                    <i class="nameWave-3"></i>
                    <div class="nameCont">
                        <p>MPA(英国) “10.”</p>
                    </div>
                    <a class="domain domain-1" href="https://www.doi.org" target="_blank">
                        <h3 class="logo"><img src="./../../assets/img/MPAlogo/british.png" alt="">英国-主要应用：</h3>
                        <p>学术期刊、建筑行业供应链等</p>
                    </a>
                </div>
                <div class="nameLists nameList-2">
                    <i class="nameWave-1"></i>
                    <i class="nameWave-2"></i>
                    <i class="nameWave-3"></i>
                    <div class="nameCont">
                        <p>MPA(德国) “21.”</p>
                    </div>
                    <a class="domain domain-2" href="https://gwdg.de" target="_blank">
                        <h3 class="logo"><img src="./../../assets/img/MPAlogo/Germany1.png" alt="">德国-主要应用：</h3>
                        <p>科学大数据的数据共享等。</p>
                    </a>
                </div>
                <div class="nameLists nameList-3">
                    <i class="nameWave-1"></i>
                    <i class="nameWave-2"></i>
                    <i class="nameWave-3"></i>
                    <div class="nameCont">
                        <p>MPA( ITU )  “11.”</p>
                    </div>
                    <a class="domain domain-3" href="https://www.itu.int/zh/Pages/default.aspx#/zh" target="_blank">
                        <h3 class="logo"><img src="./../../assets/img/MPAlogo/ITU1.png" alt="">ITU-主要应用：</h3>
                        <p>内部文档管理</p>
                    </a>
                </div>
                <div class="nameLists nameList-4">
                    <i class="nameWave-1"></i>
                    <i class="nameWave-2"></i>
                    <i class="nameWave-3"></i>
                    <div class="nameCont">
                        <p>MPA(俄罗斯) “77.”</p>
                    </div>
                    <a class="domain domain-4" href="https://www.company.rt.ru/en/" target="_blank">
                        <h3 class="logo"><img src="./../../assets/img/MPAlogo/Rostelecom.png" alt="">俄罗斯-主要应用：</h3>
                        <p>物品追溯、物联网等</p>
                    </a>
                </div>
                <div class="nameLists nameList-5">
                    <i class="nameWave-1"></i>
                    <i class="nameWave-2"></i>
                    <i class="nameWave-3"></i>
                    <div class="nameCont">
                        <p>MPA(突尼斯) “44.”</p>
                    </div>
                    <a class="domain domain-5" href="https://www.ati.tn/" target="_blank">
                        <h3 class="logo"><img src="./../../assets/img/MPAlogo/ATI.png" alt="">突尼斯-主要应用：</h3>
                        <p>电子政务、电子健康等</p>
                    </a>
                </div>
                <div class="nameLists nameList-6">
                    <i class="nameWave-1"></i>
                    <i class="nameWave-2"></i>
                    <i class="nameWave-3"></i>
                    <div class="nameCont">
                        <p>MPA(沙特) “22.”</p>
                    </div>
                    <a class="domain domain-6" href="https://www.cst.gov.sa/en/Pages/default.aspx" target="_blank">
                        <h3 class="logo"><img src="./../../assets/img/MPAlogo/CITC.png" alt="">沙特-主要应用：</h3>
                        <p>物联网基础设施</p>
                    </a>
                </div>
                <div class="nameLists nameList-7">
                    <i class="nameWave-1"></i>
                    <i class="nameWave-2"></i>
                    <i class="nameWave-3"></i>
                    <div class="nameCont">
                        <p>MPA(卢旺达) “25.”</p>
                    </div>
                    <a class="domain domain-7" href="https://smartafrica.org/" target="_blank">
                        <h3 class="logo"><img class="amart" src="./../../assets/img/MPAlogo/amart.png" alt="">卢旺达-主要应用：</h3>
                        <p>电子政务、电子健康等</p>
                    </a>
                </div>
                <div class="nameLists nameList-8">
                    <i class="nameWave-1"></i>
                    <i class="nameWave-2"></i>
                    <i class="nameWave-3"></i>
                    <div class="nameCont">
                        <p>MPA(南非) “27.”</p>
                    </div>
                    <a class="domain domain-8" href="https://smartafrica.org/" target="_blank">
                        <h3 class="logo"><img class="amart" src="./../../assets/img/MPAlogo/amart.png" alt="">南非-主要应用：</h3>
                        <p>电子政务、电子健康等</p>
                    </a>
                </div>
                <div class="nameLists nameList-9">
                    <div class="nameCont">
                        <p>MPA(中国) “86.、108.”</p>
                    </div>
                    <i class="nameWave-1"></i>
                    <i class="nameWave-2"></i>
                    <i class="nameWave-3"></i>
                    <router-link to="/MPAintroduce" class="domain domain-9">
                        <h3 class="logo"><img src="./../../assets/img/MPAlogo/MPA.png" alt="">中国-主要应用：</h3>
                        <p>工业互联网、大数据、区块链</p>
                    </router-link>
                </div>
                <div class="nameLists nameList-10">
                    <i class="nameWave-1"></i>
                    <i class="nameWave-2"></i>
                    <i class="nameWave-3"></i>
                    <div class="nameCont">
                        <p>MPA(美国) “20.”</p>
                    </div>
                    <a class="domain domain-10" href="" target="_blank">
                        <h3 class="logo"><img src="./../../assets/img/MPAlogo/CNRI.png" alt="">美国-主要应用：</h3>
                        <p>影视行业、EIDR标识符等</p>
                    </a>
                </div>
                <div class="nameLists nameList-11">
                    <i class="nameWave-1"></i>
                    <i class="nameWave-2"></i>
                    <i class="nameWave-3"></i>
                    <div class="nameCont">
                        <p>青岛</p>
                    </div>
                    <router-link to="/NetRootQD" class="domain domain-11" target="_blank">
                        <h3 class="logo"><img src="./../../assets/img/MPAlogo/MPA.png" alt="">青岛-主要应用：</h3>
                        <p>工业互联网、大数据、区块链</p>
                    </router-link>
                </div>
                <div class="nameLists nameList-12">
                    <i class="nameWave-1"></i>
                    <i class="nameWave-2"></i>
                    <i class="nameWave-3"></i>
                    <div class="nameCont">
                        <p>香港 </p>
                    </div>
                    <a class="domain domain-12" href="javascript:;">
                        <h3 class="logo"><img src="./../../assets/img/MPAlogo/MPA.png" alt="">香港-主要应用：</h3>
                        <p>工业互联网、大数据、区块链</p>
                    </a>
                </div>
                <!-- <div class="nameLists nameList-13">
                    <i class="nameWave-1"></i>
                    <i class="nameWave-2"></i>
                    <i class="nameWave-3"></i>
                    <div class="nameCont">
                        <p>长沙</p>
                    </div>
                    <a class="domain domain-13" href="javascript:;">
                        <h3 class="logo"><img src="" alt="">长沙-主要应用：</h3>
                        <p>工业互联网、大数据、区块链</p>
                    </a>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'homeMap',
  methods: {
  }
}
</script>

<style lang="less" scoped>
.homeMap{
    width: 100%;
    // background: #f5f7fa;
    .main{
        width: 1200px;
        margin: auto;
        padding-bottom: 80px;
        .titbox{
            width: 100%;
            text-align: center;
            color:#333;
            padding:70px 0;
            h3{
                font-size: 36px;
                line-height: 1.3;
            }
            p{
                font-size: 16px;
                color:#666;
                margin-top:15px
            }
        }
        .mapbox{
            width: 100%;
            position: relative;
            // transform: rotate3d(138, 0, 0.5, 0.7rad);
            top: 0px;
            .nameLists:hover{
                .domain{
                    display: block;
                }
            }
            .nameLists {
                position: absolute;
                left:50%;
                .webLink{
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                }
                .activeShow{
                    display: block;
                }
                .domain{
                    width: 220px;
                    height: auto;
                    position: absolute;
                    top:0;
                    left: 0;
                    z-index: 5;
                    background: #fff;
                    box-shadow: 5px 1px 5px #cecece;
                    padding: 5px 12px;
                    color: #000;
                    display: none;
                    h3{
                        font-size: 16px;
                        line-height: 24px;
                        img{
                            width:30px;
                            height: 30px;
                            display: inline-block;
                            vertical-align:middle;
                            margin-right: 8px;
                        }
                        img.amart{
                            width: 50px;
                            height: 15px;
                        }
                    }
                    p{
                        font-size: 14px;
                    }
                }
                .nameWave-1{
                    width: 34px;
                    height:34px;
                    display: block;
                    background-color:#fb5144;
                    border-radius: 50%;
                    opacity: .3;
                    animation: circle_wave 2s ease-out infinite both ;
                }
                .nameWave-2{
                    width: 24px;
                    height:24px;
                    display: block;
                    background-color:#fb5144;
                    border-radius: 50%;
                    animation: circle_wave 2s ease-out infinite both ;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    margin:-12px 0 0 -12px;
                    opacity: 0.7;
                    animation-delay: 0.8s;
                }
                .nameWave-3{
                    width:12px;
                    height:12px;
                    display: block;
                    background-color:#fb5144;
                    border-radius: 50%;
                    position: absolute;
                    left: 50%;
                    top:50%;
                    margin:-6px 0 0 -6px
                }
            }
            .nameList-1 {
                margin-left:-560px;
                top:97px;
                .domain-1{
                    position: absolute;
                    top: -53px;
                    left: -202px;
                    background: #fff;
                    box-shadow: 5px 1px 5px #cecece;
                    padding: 5px 12px;
                }
                .nameCont{
                    position: absolute;
                    width: 110px;
                    left: 50%;
                    top:50%;
                    margin: -35px 0 0 -80px;
                    font-weight: bold;
                    text-align: center;
                    line-height: 20px;
                }
            }
            .nameList-2 {
                margin-left:-521px;
                top:84px;
                .domain-2{
                    position: absolute;
                    top: -54px;
                    left: 44%;
                    background: #fff;
                    box-shadow: 5px 1px 5px #cecece;
                    padding: 5px 12px;
                }
                .nameWave-1,
                .nameWave-2{
                    animation-delay: .8s;
                }
                .nameCont{
                    position: absolute;
                    width: 110px;
                    left: 50%;
                    top:50%;
                    margin: -37px 0 0 -28px;
                    font-weight: bold;
                    text-align: center;
                    line-height: 20px;
                }
            }
            .nameList-3 {
                margin-left:-540px;
                top:116px;
                .nameWave-1,
                .nameWave-2{
                    animation-delay: 1.0s;
                }
                .nameCont{
                    position: absolute;
                    width: 110px;
                    left: 50%;
                    top:50%;
                    margin: -12px 0 0 -8px;
                    font-weight: bold;
                    text-align: center;
                    line-height: 20px;
                }
            }
            .nameList-4 {
                margin-left:-374px;
                top:73px;
                .nameWave-1,
                .nameWave-2{
                    animation-delay: 1.2s;
                }
                .nameCont{
                    position: absolute;
                    width: 110px;
                    left: 50%;
                    top:50%;
                    margin: 10px 0 0 -52px;
                    font-weight: bold;
                    text-align: center;
                    line-height: 20px;
                }
            }
            .nameList-5 {
                margin-left:-536px;
                top:169px;
                .nameWave-1,
                .nameWave-2{
                    animation-delay: 1.4s;
                }
                .nameCont{
                    position: absolute;
                    width: 110px;
                    left: 50%;
                    top:50%;
                    margin: 10px 0 0 -52px;
                    font-weight: bold;
                    text-align: center;
                    line-height: 20px;
                }
            }
            .nameList-6 {
                margin-left:-414px;
                top:200px;
                .nameWave-1,
                .nameWave-2{
                    animation-delay: 1.6s;
                }
                .nameCont{
                    position: absolute;
                    width: 110px;
                    left: 50%;
                    top:50%;
                    margin: 10px 0 0 -52px;
                    font-weight: bold;
                    text-align: center;
                    line-height: 20px;
                }
            }
            .nameList-7 {
                margin-left:-475px;
                top:314px;
                .nameWave-1,
                .nameWave-2{
                    animation-delay: 1.8s;
                }
                .nameCont{
                    position: absolute;
                    width: 110px;
                    left: 50%;
                    top:50%;
                    margin: 10px 0 0 -52px;
                    font-weight: bold;
                    text-align: center;
                    line-height: 20px;
                }
            }
            .nameList-8 {
                margin-left:-487px;
                top:386px;
                .nameWave-1,
                .nameWave-2{
                    animation-delay: 1.9s;
                }
                .nameCont{
                    position: absolute;
                    width: 110px;
                    left: 50%;
                    top:50%;
                    margin: 10px 0 0 -52px;
                    font-weight: bold;
                    text-align: center;
                    line-height: 20px;
                }
            }
            .nameList-9 {
                margin-left:-203px;
                top:135px;
                .nameWave-1,
                .nameWave-2{
                    animation-delay: 2.0s;
                }
                .nameCont{
                    position: absolute;
                    width: 110px;
                    left: 50%;
                    top:50%;
                    margin: -50px 0 0 -53px;
                    font-weight: bold;
                    text-align: center;
                    line-height: 20px;
                }
            }
            .nameList-10 {
                margin-left:321px;
                top:117px;
                .nameWave-1,
                .nameWave-2{
                    animation-delay: 2.2s;
                }
                .nameCont{
                    position: absolute;
                    width: 110px;
                    left: 50%;
                    top:50%;
                    margin: 10px 0 0 -52px;
                    font-weight: bold;
                    text-align: center;
                    line-height: 20px;
                }
            }
            .nameList-11 {
                margin-left:-203px;
                top:150px;
                .nameWave-1,
                .nameWave-2,
                .nameWave-3{
                    background-color: #ffb458;
                }
                .nameWave-1,
                .nameWave-2{
                    animation-delay: 2.24s;
                }
                .nameCont{
                    position: absolute;
                    width: 110px;
                    left: 50%;
                    top:50%;
                    margin: 10px 0 0 -52px;
                    font-weight: bold;
                    text-align: center;
                    line-height: 20px;
                }
            }
            .nameList-12 {
                margin-left:-214px;
                top:200px;
                .nameWave-1,
                .nameWave-2,
                .nameWave-3{
                    background-color: #ffb458;
                }
                .nameWave-1,
                .nameWave-2{
                    animation-delay: 2.26s;
                }
                .nameCont{
                    position: absolute;
                    width: 110px;
                    left: 50%;
                    top:50%;
                    margin: 10px 0 0 -52px;
                    font-weight: bold;
                    text-align: center;
                    line-height: 20px;
                }
            }
            .nameList-13 {
                margin-left:-230px;
                top:177px;
                .nameWave-1,
                .nameWave-2,
                .nameWave-3{
                    background-color: #ffb458;
                }
                .nameWave-1,
                .nameWave-2{
                    animation-delay: 2.26s;
                }
                .nameCont{
                    position: absolute;
                    width: 110px;
                    left: 50%;
                    top:50%;
                    margin: 10px 0 0 -60px;
                    font-weight: bold;
                    text-align: center;
                    line-height: 20px;
                }
            }
        }
    }
    @keyframes circle_wave{
        0%{opacity:1;transform:scale(0)}
        40%{opacity:.1;transform:scale(1.5)}
        100%{opacity:0;transform:scale(1.5)}
    }
}
@media screen and (max-width:1000px) {
  .homeMap{
    .main{
      width:100%;
      .mapbox{
          .mapImg{
              width:100%;
              img {
                  width:100%;
                  height: auto;
              }
          }
          .nameLists {
                position: absolute;
                left:0;
                .nameCont{
                    width:80px;
                    line-height: 14px;
                }
                .nameWave-1{
                    width: 34px;
                    height:34px;
                    display: block;
                    font-size:12px;
                    background-color:#fb5144;
                    border-radius: 50%;
                    opacity: .3;
                    animation: circle_wave 2s ease-out infinite both ;
                }
                .nameWave-2{
                    width: 24px;
                    height:24px;
                    display: block;
                    background-color:#fb5144;
                    border-radius: 50%;
                    animation: circle_wave 2s ease-out infinite both ;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    margin:-12px 0 0 -12px;
                    opacity: 0.7;
                    animation-delay: 0.8s;
                }
                .nameWave-3{
                    width:12px;
                    height:12px;
                    display: block;
                    background-color:#fb5144;
                    border-radius: 50%;
                    position: absolute;
                    left: 50%;
                    top:50%;
                    margin:-6px 0 0 -6px
                }
            }
            .nameList-1 {
                margin-left:3px;
                top:19px;
                .nameCont{
                    position: absolute;
                    left: 50%;
                    top:50%;
                    margin: -57px 0 0 -33px;
                    font-weight: bold;
                    text-align: center;
                }
            }
            .nameList-2 {
                margin-left:24px;
                top:20px;
                .nameWave-1,
                .nameWave-2{
                    animation-delay: .8s;
                }
                .nameCont{
                    position: absolute;
                    left: 50%;
                    top:50%;
                    margin: -25px 0 0 -28px;
                    font-weight: bold;
                    text-align: center;
                }
            }
            .nameList-3 {
                margin-left:-10px;
                top:31px;
                .nameWave-1,
                .nameWave-2{
                    animation-delay: 1.0s;
                }
                .nameCont{
                    position: absolute;
                    left: 50%;
                    top:50%;
                    margin: 0 0 0 -8px;
                    font-weight: bold;
                    text-align: center;
                }
            }
            .nameList-4 {
                margin-left:92px;
                top:12px;
                .nameWave-1,
                .nameWave-2{
                    animation-delay: 1.2s;
                }
                .nameCont{
                    position: absolute;
                    left: 50%;
                    top:50%;
                    margin: -32px 0 0 -36px;
                    font-weight: bold;
                    text-align: center;
                }
            }
            .nameList-5 {
                margin-left:11px;
                top:51px;
                .nameWave-1,
                .nameWave-2{
                    animation-delay: 1.4s;
                }
                .nameCont{
                    position: absolute;
                    left: 50%;
                    top:50%;
                    margin: 10px 0 0 -52px;
                    font-weight: bold;
                    text-align: center;
                }
            }
            .nameList-6 {
                margin-left:47px;
                top:57px;
                .nameWave-1,
                .nameWave-2{
                    animation-delay: 1.6s;
                }
                .nameCont{
                    position: absolute;
                    left: 50%;
                    top:50%;
                    margin: 5px 0 0 -25px;
                    font-weight: bold;
                    text-align: center;
                }
            }
            .nameList-7 {
                margin-left:29;
                top:93px;
                .nameWave-1,
                .nameWave-2{
                    animation-delay: 1.8s;
                }
                .nameCont{
                    position: absolute;
                    left: 50%;
                    top:50%;
                    margin: -6px 0 0 2px;
                    font-weight: bold;
                    text-align: center;
                }
            }
            .nameList-8 {
                margin-left:27px;
                top:110px;
                .nameWave-1,
                .nameWave-2{
                    animation-delay: 1.9s;
                }
                .nameCont{
                    position: absolute;
                    left: 50%;
                    top:50%;
                    margin: 10px 0 0 -33px;
                    font-weight: bold;
                    text-align: center;
                }
            }
            .nameList-9 {
                margin-left:118px;
                top:33px;
                .nameWave-1,
                .nameWave-2{
                    animation-delay: 2.0s;
                }
                .nameCont{
                    position: absolute;
                    left: 50%;
                    top:50%;
                    margin: -32px 0 0 -23px;
                    font-weight: bold;
                    text-align: center;
                }
            }
            .nameList-10 {
                margin-left:298px;
                top:25px;
                .nameWave-1,
                .nameWave-2{
                    animation-delay: 2.2s;
                }
                .nameCont{
                    position: absolute;
                    left: 50%;
                    top:50%;
                    margin: 10px 0 0 -52px;
                    font-weight: bold;
                    text-align: center;
                }
            }
            .nameList-11 {
                margin-left:120px;
                top:45px;
                .nameWave-1,
                .nameWave-2,
                .nameWave-3{
                    background-color: #ffb458;
                }
                .nameWave-1,
                .nameWave-2{
                    animation-delay: 2.24s;
                }
                .nameCont{
                    position: absolute;
                    left: 50%;
                    top:50%;
                    margin: -13px 0 0 -7px;
                    font-weight: bold;
                    text-align: center;
                }
            }
            .nameList-12 {
                margin-left:116px;
                top:62px;
                .nameWave-1,
                .nameWave-2,
                .nameWave-3{
                    background-color: #ffb458;
                }
                .nameWave-1,
                .nameWave-2{
                    animation-delay: 2.26s;
                }
                .nameCont{
                    position: absolute;
                    left: 50%;
                    top:50%;
                    margin: -4px 0 0 -9px;
                    font-weight: bold;
                    text-align: center;
                }
            }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/Home/components/map.vue